export const getSurveysBegin = "GET_SURVEYS_BEGIN";
export const getSurveysSuccess = "GET_SURVEYS_SUCCESS";
export const getSurveysFailure = "GET_SURVEYS_FAILURE";
export const selectedItemsChanged = "SURVEYS_OVERVIEW_SELECTED_ITEMS_CHANGED";
export const reset = "SURVEYS_OVERVIEW_RESET";
